import { HostDto } from "./host.dto";
export class AccomodationDto{
    /*
    *
    */
   constructor(
        public id?: number,
        public name?: string,
        public fullAddress?: string,
        public latitude?: number,
        public longitude?: number,
        public qrCodeImg?: string,
        public active?: boolean,
        public creationDate?: string,
        public updateDate?: string,
        public logo?: string,
        public imgMobile?: string,
        public imgDesktop?: string,
        public qrCodeId?: string,
        public lastVisitDate?: string,
        public host?: HostDto
    ){}
}